import React from 'react'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

interface NumberChartProps {
  data: any
}

const NumberChart: React.FC<NumberChartProps> = ({ data }) => {

  return <ResponsiveContainer width='100%' height={300}>
    <BarChart
      width={500}
      height={300}
      data={data?.map(value => ({ name: value.value, count: value.count }))}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5
      }}
    >
      <CartesianGrid strokeDasharray='3 3' />
      <XAxis dataKey='name' />
      <YAxis allowDecimals={false} />
      <Tooltip cursor={{ fill: 'transparent' }} />
      <Bar maxBarSize={35} dataKey='count' fill='#8884d8' />
    </BarChart>
  </ResponsiveContainer>
}
export default NumberChart